import React from 'react';

const Scanlines = () => {
  return (
    <>
      <div className="scanlines"></div>
      <div className="vhs-overlay"></div>
    </>
  );
};

export default Scanlines;
